<template>
	<div class="cloud-location">
		<div class="cloud-location-l">
			<div class="cloud-location-title">
				<div class="cloud-location-title-title">
					<img src="@/assets/images/groupTitle.png" alt="" />
					<p>当天在洞汇总人数</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 86%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-location-title-content">
					<div id="main_location" class="chart-container" style="width: 100%; height: 33vh;"></div>
				</div>
			</div>
			<div class="cloud-location-title" style="margin-top: 1vh;">
				<div class="cloud-location-title-title">
					<img src="@/assets/images/groupTitle.png" alt="" />
					<p>当天各个岗位在洞人数</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 86%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-location-title-content">
					<ul class="cloud-location-title-content-ul">
						<li v-for="(item, index) in deptSummary" :key="index">
							<div>
								<p>{{ item.name }}</p>
								<p>{{ item.totalCount }}</p>
							</div>
							<div><el-progress :percentage="handlePercentage(item.totalCount)" color="#1989fa"
									:stroke-width="15" :text-inside="true"></el-progress></div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="cloud-location-c">
			<iframe style="width: 100%; height: 83.81vh; margin-top: 1vh;" :src="srcPath" frameborder="0"></iframe>
		</div>
		<div class="cloud-location-r">
			<div class="cloud-location-title" style="width: 100%; height: 84.5vh;">
				<div class="cloud-location-title-title">
					<img src="@/assets/images/groupTitle.png" alt="" />
					<p>当前进洞人员信息</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 86%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-location-title-content" style="width: 100%; height: 80vh; overflow: hidden; ">
					<div class="cloud-location-title-content-table">
						<p>姓名</p>
						<p>班组</p>
						<p>岗位</p>
						<p>距离</p>
						<p>掌子面/洞口</p>
						<p>定位时间</p>
					</div>
					<div
						style="width: 100%; height: 78vh; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(150, 150, 150, 0.2) transparent;">
						<div class="cloud-location-title-content-table" v-for="(item, index) in workforceData"
							:key="index">
							<p>{{ item.name }}</p>
							<p>{{ item.deptName }}</p>
							<p>{{ item.postName }}</p>
							<p>{{ Math.floor(item.xCoordinate) }}米</p>
							<p>{{ Math.floor(item.xCoordinate) <= 30 ? '洞内' : '掌子面' }}</p>
									<p>{{ formatDateAll(item.positioningTime, "hh:mm") }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { itemPie, getDay, formatDateAll, handlePercentage, getRandomNumber,getLocalStorageWithExpiry } from '@/utils/index.js'
import * as echarts from 'echarts';
import { personInTunnel, personInTunnelToday } from '@/public/api.js'
import { personInTunnelData, personInTunnelTodayData } from './locationData.js'

// 引入路由实例
export default {
	name: 'location',
	components: {
	},
	data() {
		return {
			myChart_Personnel: null,
			srcPath: '',
			TunnelsData: {},
			timer: null,
			workforceData: [], // 当前洞内人员信息
			personnelPostData: [], // 岗位人员数据
			form: {
				itemId: '',
				date: getDay(), // 结束时间
				pageNum: 1, // 页码
				pageSize: 10 // 每页显示条数
			},
			deptSummary: [], // 部门汇总数据
			postSummary: [], // 岗位汇总数据
			hostName: window.location.hostname
		}
	},
	computed: {

	},
	mounted() {

		let that = this;
		that.TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));
		that.form.itemId = that.TunnelsData.itemId;

		// 初始化图表
		this.myChart_Personnel = echarts.init(document.getElementById('main_location'));

		// 监听窗口大小变化，自动调整图表
		window.addEventListener('resize', this.handleResize);

		this.timer = setInterval(() => {
			that.getPersonInTunnel(); // 初始化获取当前在洞人员
			that.getPersonInTunnelToday(); // 初始化获取当前在洞人员
		}, 5000);


		that.getPersonInTunnel(); // 初始化获取当前在洞人员
		that.getPersonInTunnelToday(); // 初始化获取当前在洞人员

		if (that.hostName == 'localhost' || that.hostName == '127.0.0.1' || that.hostName == '39.100.79.198' || that.hostName == 'sd.yongsixinxi.com') {
			that.hostName = 'https://' + '3d.yongsixinxi.com';
		} else{
			that.hostName = "http://39.101.122.159:9990";
		}

		if (this.TunnelsData.itemTunnelType == '1') {
			this.srcPath = that.hostName + '/tunnelModelLeft?id=' + getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else if (this.TunnelsData.itemTunnelType == '2') {
			this.srcPath = that.hostName + '/tunnelModelRight?id=' + getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else if (this.TunnelsData.itemTunnelType == '3') {
			this.srcPath = that.hostName + '/tunnelModelXj?id=' + getRandomNumber(1000) +
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else if (this.TunnelsData.itemTunnelType == '5') {
			this.srcPath = that.hostName + '/tunnelModelSx?id=' + getRandomNumber(1000)+
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else if (this.TunnelsData.itemTunnelType == '4') {
			this.srcPath = that.hostName + '/tunnelModelStd?id=' + getRandomNumber(1000)+
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else if (this.TunnelsData.itemTunnelType == '7') {
			this.srcPath = that.hostName + '/tunnelModelSxdXj?id=' + getRandomNumber(1000)+
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		} else {
			this.srcPath = that.hostName + '/tunnelModelLeft?id=' + getRandomNumber(1000)+
        "&token=" +
        getLocalStorageWithExpiry("updateToken") +
        "&updateTunnelItemId=" +
        that.TunnelsData.itemId;
		}
	},
	methods: {
		handlePercentage,
		formatDateAll,
		getPersonInTunnel() { // 获取当前在洞人员
			let that = this;
			// that.personnelPostData = [];  // 清空岗位人员数据
			if (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1' || window.location.hostname == '39.100.79.198' || window.location.hostname == 'sd.yongsixinxi.com') {
				that.workforceData = personInTunnelData(); //掌子面施工人员信息
			} else{
				personInTunnel(that.form).then(res => {
					if (res.data.code === 200) {
						that.workforceData = res.data.data;//掌子面施工人员信息
					}
				})
			}
		},
		getPersonInTunnelToday() { // 获取当前在洞人员
			let that = this;
			
			personInTunnelToday(that.form).then(res => {
				if (res.data.code === 200) {
					let workforceDayData = res.data.data;//掌子面施工人员信息
					if (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1' || window.location.hostname == '39.100.79.198' || window.location.hostname == 'sd.yongsixinxi.com') {
						workforceDayData = personInTunnelTodayData(); //掌子面施工人员信息
					} 

					// 部门汇总：得到 [{name: '部门1', totalCount: 数量}, ...]
					that.deptSummary = workforceDayData.reduce((acc, item) => {
						const deptName = item.deptName;
						// 查找当前部门是否已在汇总数组中
						const existing = acc.find(d => d.name === deptName);

						if (existing) {
							// 已存在则数量+1
							existing.totalCount++;
						} else {
							// 不存在则新增一条记录
							acc.push({ name: deptName, totalCount: 1 });
						}

						return acc;
					}, []); // 初始值为 empty 数组


					// 岗位汇总：得到 [{name: '岗位1', totalCount: 数量}, ...]
					that.postSummary = workforceDayData.reduce((acc, item) => {
						const postName = item.postName;
						// 查找当前岗位是否已在汇总数组中
						const existing = acc.find(p => p.name === postName);

						if (existing) {
							// 已存在则数量+1
							existing.totalCount++;
						} else {
							// 不存在则新增一条记录
							acc.push({ name: postName, totalCount: 1 });
						}

						return acc;
					}, []); // 初始值为 empty 数组

					that.axisLineCqrs(that.postSummary);
				}
			})
		},
		axisLineCqrs(postSummary) {
			let xAxisData = []
			let legendData = []
			let seriesData = []
			postSummary.forEach(item => {
				legendData.push(item.name);
				seriesData.push({ value: item.totalCount, name: item.name }, // 深青色},
				);
			})

			let option = itemPie(legendData, xAxisData, seriesData)
			this.myChart_Personnel.setOption(option);
		},
		// 窗口大小变化时调整图表
		handleResize() {
			if (this.myChart_Personnel) {
				this.myChart_Personnel.resize();
			}
		},
	},
	beforeDestroy() {
		// 移除事件监听，销毁图表
		window.removeEventListener('resize', this.handleResize);
		if (this.myChart_Personnel) {
			this.myChart_Personnel.dispose();
		}

		// 组件销毁前清除定时器
		if (this.timer) {
			clearInterval(this.timer);
		}
	}
}
</script>
<style scoped>
.cloud-location {
  position: relative;
  top: 1%;
  left: 1%;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

	/* 新增：确保padding不撑大容器 */

	.cloud-location-l {
		width: 20%;
		height: 100%;
		float: left;
	}

	.cloud-location-c {
		width: 57.3%;
		height: 100%;
		float: left;
		margin-left: 0.5vw;
		margin-right: 0.5vw;
	}

	.cloud-location-r {
		width: 20%;
		height: 100%;
		float: left;
	}

	.cloud-location-title {
		position: relative;
		margin-top: 1vh;
		left: 0;
		width: 100%;
		height: calc(450 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;
		overflow: hidden;
		/* 新增：禁止子元素超出父容器 */
		box-sizing: border-box;
		/* 新增：确保padding不撑大容器 */

		>.cloud-location-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
				overflow: hidden;
				/* 新增：禁止子元素超出父容器 */
				box-sizing: border-box;
				/* 新增：确保padding不撑大容器 */
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
				white-space: nowrap;
				/* 关键：禁止文本换行 */
				text-overflow: ellipsis;
				/* 关键：超出部分显示省略号 */
				overflow: hidden;
				/* 关键：配合text-overflow生效 */
				max-width: calc(100% - 4vh);
				/* 新增：限制文本最大宽度，避免超出父容器 */
			}
		}

		.cloud-location-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 93%;
			height: calc(385 / 1080 * 100vh);
			margin: 0;
			padding: 10px;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
			overflow-y: auto;
			/* 保留纵向滚动，禁止横向滚动 */
			overflow-x: hidden;
			/* 关键：禁止横向内容跳出 */
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
			box-sizing: border-box;
			/* 确保padding不撑大宽度 */
		}
	}


	::v-deep .el-progress__text {
		font-size: 0.8rem !important;
		margin-left: 20px !important;
		color: #fff;
	}


	/* 图表容器样式 */
	.chart-container {
		width: 100%;
		height: 100%;
		/* 设置最小高度，避免过小 */
		box-sizing: border-box;
		padding: 5px;
		/* 增加内边距，避免内容贴边 */
	}

	.cloud-location-title-content-ul {
		list-style: none;
		margin: 0;
		padding: 0;
		margin-top: 2vh;

		>li {
			width: 100%;
			height: 6.5vh;
			margin: 0;
			padding: 0;

			>div {
				width: 100%;
				height: 3vh;
				margin: 0;
				padding: 0;
				text-align: left;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 0.8rem;
				color: #999;
				font-style: normal;
				text-transform: none;

				>p:nth-child(1) {
					width: 60%;
					height: 2.5vh;
					line-height: 2.5vh;
					margin: 0px;
					padding: 0px;
					float: left;
				}

				>p:nth-child(2) {
					width: 30%;
					height: 2.5vh;
					line-height: 2.5vh;
					margin: 0px;
					padding: 0px;
					float: right;
					text-align: right;
				}
			}
		}
	}

	.cloud-location-title-content-table {
		width: 100%;
		height: 2.5vh;
		margin: 0;
		padding: 0;
		margin-top: 1vh;

		>p {
			height: 2.5vh;
			margin: 0;
			padding: 0;
			float: left;
			line-height: 2.5vh;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.7rem;
			color: rgba(255, 255, 255, 0.6);
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		>p:nth-child(1) {
			width: 15%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(2) {
			width: 15%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(3) {
			width: 13%;
		}

		>p:nth-child(4) {
			width: 15%;
		}

		>p:nth-child(5) {
			width: 18%;
		}

		>p:nth-child(6) {
			width: 15%;
		}

	}
}
</style>